import angular from 'angular';

import component from './modifier-groups-manage.component';

const ModifierGroupsManage = angular
    .module('control-room.components.menus.components.modifier-groups-manage', [])
    .component('crModifierGroupsManage', component);

export default ModifierGroupsManage;
